require('babel-polyfill');

define(['jquery', 'redux', './redux/reducer-manager','observer-pattern', 'publish-subscribe-pattern', 'jquery.easing'], function ($, redux,reduxManager, observerPattern, publishSubscribePattern, easing) {

    $.fn.extend({
        animateCss: function (animationName, callback) {
            var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
            this.addClass('animate__animated ' + animationName).one(animationEnd, function () {
                $(this).removeClass(animationName);
                if (callback) {
                    callback();
                }
            });
            return this;
        }
    });

    window.requestAnimFrame = (function () {
        return  window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            function (callback) {
                window.setTimeout(callback, 1000 / 60);
            };
    })();

    var container = (function () {

        const { combineReducers, createStore } = redux;

        const reducerManager = reduxManager.createReducerManager(false, combineReducers);
        const store = createStore(reducerManager.reduce, {});

        store.reducerManager = reducerManager;

        return {
            /*
             * Perform copy of properties from object to object
             * It's a deep copy so complex objects are also copied.
             * @param Object outputObject object to copy properties
             * @param Object copyObject object from which properties are copied
             */
            performCopy: function (outputObject, copyObject) {
                outputObject = outputObject || {};
                copyObject = copyObject || {};

                for (var i in copyObject) {
                    if (typeof copyObject[i] === 'object') {
                        if (!outputObject[i])
                        {
                            outputObject[i] = (copyObject[i].constructor === Array) ? [] : {};
                        }
                        this.performCopy(outputObject[i], copyObject[i]);
                    }
                    else {
                        outputObject[i] = copyObject[i];
                    }
                }

                return outputObject;
            },
            /*
             * Show message in console
             * @param String msg - message to show
             */
            msg: function (msg) {
                if (typeof console === 'object' && typeof console.info === 'function') {
                    console.info(msg);
                }
            },
            /*
             * Get data for given element handle and field name based on datasets
             * @param Resource element - element which has attribute
             * @param String field - attribute name
             *
             * @call
             * <div id="some-id" data-some.data="11"></div>
             * container.getData($('#some-id')[0], 'some.data');
             */
            getData: function (element, field) {

                var value = '';

                if (element.dataset !== undefined) { // standard approach
                    value = element.dataset[field];
                } else {
                    value = element.getAttribute('data-' + field); // IE approach
                }

                return value;
            },

            /*
             * Set data for given element handle and field name based on datasets
             * @param Resource element - element which has attribute
             * @param String field - attribute name
             * @param String value
             *
             * @call
             * <div id="some-id" data-some.data="11"></div>
             * container.getData($('#some-id')[0], 'some.data', 'some value');
             */
            setData: function (element, field, value) {

                if (element.dataset !== undefined) { // standard approach
                    element.dataset[field] = value;
                } else {
                    element.setAttribute('data-' + field, value); // IE approach
                }
            },

            /*
             * Track page for statistics
             * @param String id - string of something that should be measured
             */
            trackPageView: function (values) {
                try {
                    const data = $.extend(true, {}, turner_metadata_data, values);

                    turner_metadata.trackAction.push({
                        "type" : "pageview",
                        "data" : data
                    });
                    //Bootstrapper.ensEvent.trigger(id);
                    container.msg('stats - pageview pageName ' + data.pageName);
                } catch (e) {
                    console.log(e);
                }
            },
            trackInteraction: function (interaction, values) {
                try {

                    const data = $.extend(true, {}, turner_metadata_data, {
                        "interaction": interaction
                    }, values);

                    turner_metadata.trackAction.push({
                        "type" : "interaction",
                        "data" : data
                    });
                    //Bootstrapper.ensEvent.trigger(id);
                    container.msg('stats - interaction pageName ' + data.pageName + ' interaction: ' + interaction);
                } catch (e) {
                    console.log(e);
                }
            },
            /*
             * Get base view for modules
             */
            getBaseView: function (name) {

                let systemName = name || 'system';

                var privateView = {
                    model: {},
                    privateVars: {},
                    publicVars: {},
                    init: function (options) {

                        var viewOptions = options.view || {};
                        $.extend(true, this.publicVars, viewOptions);

                        this.prepareView();

                        container.msg(systemName + ' - view init done');

                    },
                    prepareView: function () {

                        this.startup();
                        this.bind();

                    },
                    startup: function () {

                    },
                    bind: function () {

                    }

                }

                return privateView;
            },
            /*
             * Get base model for modules
             */
            getBaseModel: function (name) {

                let systemName = name || 'system';

                var privateModel = {
                    privateVars: {},
                    publicVars: {},
                    init: function (options) {

                        var modelOptions = options.model || {};
                        $.extend(true, this.publicVars, modelOptions);

                        container.msg(systemName + ' - model init done');

                    }

                }

                return privateModel;
            },
            /*
             * Get Observer Pattern
             */
            getObserver: function () {
                return observerPattern;
            },
            /*
             * Get Publish Subscribe Pattern
             */
            getPublishSubscribe: function () {
                return publishSubscribePattern;
            },

            getReduxStore: () => {
                return store;
            }
        };
    })();

    return container;

});